import { gql } from "@apollo/client"


export const CREATE_PREORDER_LOGICTICS = gql `
mutation ConfirmPreOrderDelivery($where: OrderDeliveryWhereInput!, $data: OrderDeliveryInput!) {
    confirmPreOrderDelivery(where: $where, data: $data) {
      message
    }
  }
`